import { reactive } from "vue";
import { apiFetch, ensureCsrfCookie } from "./api";

export const authState = reactive({
  user: null,
  company: null,
  loading: false,
  initialized: false,
});

export function isLoggedIn() {
  return Boolean(authState.user);
}

export async function loadCurrentUser(force = false) {
  if (authState.initialized && !force) {
    return authState.user;
  }

  authState.loading = true;

  try {
    const response = await apiFetch("/api/me", {
      method: "GET",
    });

    authState.user = response.user || null;
    authState.company = response.user?.company || null;
    authState.initialized = true;

    return authState.user;
  } catch (error) {
    authState.user = null;
    authState.company = null;
    authState.initialized = true;

    return null;
  } finally {
    authState.loading = false;
  }
}

export async function login(credentials) {
  authState.loading = true;

  try {
    await ensureCsrfCookie();

    const response = await apiFetch("/api/login", {
      method: "POST",
      body: credentials,
    });

    authState.user = response.user || null;
    authState.company = response.user?.company || null;
    authState.initialized = true;

    return response;
  } finally {
    authState.loading = false;
  }
}

export async function logout() {
  authState.loading = true;

  try {
    await apiFetch("/api/logout", {
      method: "POST",
    });
  } finally {
    authState.user = null;
    authState.company = null;
    authState.initialized = true;
    authState.loading = false;
  }
}
